// Phase 2 — semantic border radius roles
//
// Raw border radius primitives already exist as ALF atoms:
//   atoms.rounded_2xs (2)  atoms.rounded_xs (4)   atoms.rounded_sm (8)
//   atoms.rounded_md (12)  atoms.rounded_lg (16)  atoms.rounded_xl (20)
//   atoms.rounded_full (999)
//
// This file will add SEMANTIC ROLES that map a component type to the correct
// primitive, so specs say "use card radius" rather than "use 12px".
//
// Proposed roles (pending design confirmation — see FIGMA_DESIGN_SYSTEM_UPDATES.md):
//
//   component.button     → rounded_full (999) — pill buttons
//   component.card       → rounded_md   (12)  — feed cards, panels
//   component.chip       → rounded_full (999) — tags, badges
//   component.input      → rounded_sm   (8)   — text fields
//   component.dialog     → rounded_lg   (16)  — modals, bottom sheets
//   component.avatar     → rounded_full (999) — circular avatars
//   component.thumbnail  → rounded_xs   (4)   — media thumbnails
//
// Note: borderRadius values are theme-independent.
// Will be a separate primitive export, not part of semanticTokens color object.

export const borderRadius = {} as const

export type BorderRadius = typeof borderRadius
